import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrderServiceModel } from '../model/order-service.model';
import { headersBase } from '../../../../helper/headerBase';

@Injectable()
export class OrderServiceRest {

  constructor(
    private http: HttpClient
  ) { }

  public getService(page:number, param: string): Observable<OrderServiceModel[]> {
    return this.http.get<OrderServiceModel[]>(`/Order/getorderservices/${page}/${param}`, headersBase());
  }

  createshowCase(showCase: OrderServiceModel) {
    return this.http.post<OrderServiceModel>(`/showCases`, showCase, headersBase());
  }

  updateshowCase(showCase: OrderServiceModel): Observable<any> {
    return this.http.put(`/showCases`, showCase, headersBase());
  }

  deleteshowCase(id: string): Observable<any> {
    return this.http.delete(`/showCases/${id}`, headersBase());
  }

  getHomeManager(param: string): Observable<OrderServiceModel[]> {
    return this.http.get<OrderServiceModel[]>(`/home-content/${param}`, headersBase());
  }

}

